// Fotos reales de Deseos Brunch & Coffee, optimizadas en WebP.
// Archivos en /app/frontend/public/images/ — para cambiar una foto,
// sustituye el archivo con el mismo nombre.
const P = `${process.env.PUBLIC_URL || ""}/images`;

export const IMG = {
  hero: `${P}/hero.webp`,
  interior: `${P}/interior.webp`,
  latte: `${P}/matcha-latte.webp`,
  waffle: `${P}/bubble-waffle.webp`,
  matcha: `${P}/matcha-latte.webp`,
  bagel: `${P}/bocadillo-huevo.webp`,
  crepe: `${P}/tostada-aguacate.webp`,
  terrace: `${P}/entrada.webp`, // porte d'entrée, sans personne
  interiorWide: `${P}/interior-wide.webp`,
  gallery: [
    { src: `${P}/salades.webp?v=2`, alt: "Ensaladas de pollo, aguacate y queso fresco", name: "salades.webp" },
    { src: `${P}/tostada-revuelto.webp`, alt: "Tostada con huevo revuelto y pavo", name: "tostada-revuelto.webp" },
    { src: `${P}/tostada-tomate-aguacate.webp`, alt: "Tostada de tomate y aguacate con café", name: "tostada-tomate-aguacate.webp" },
    { src: `${P}/cookies.webp?v=2`, alt: "Cookies de chocolate y de vainilla con crema", name: "cookies.webp" },
    { src: `${P}/bocadillo-pollo.webp`, alt: "Bocadillo de pollo", name: "bocadillo-pollo.webp" },
    { src: `${P}/matcha-latte.webp`, alt: "Iced matcha latte de Deseos", name: "matcha-latte.webp" },
    { src: `${P}/tostada-revuelto-aguacate.webp`, alt: "Tostada de huevo revuelto y aguacate", name: "tostada-revuelto-aguacate.webp" },
    { src: `${P}/bowl-frutas.webp`, alt: "Bowl de yogur con plátano, frambuesas y granola", name: "bowl-frutas.webp" },
    { src: `${P}/sandwich-salmon.webp`, alt: "Sándwich de salmón, aguacate y pepino", name: "sandwich-salmon.webp" },
    { src: `${P}/smoothie.webp`, alt: "Smoothie de frutas en la terraza", name: "smoothie.webp" },
    { src: `${P}/tostada-pavo.webp`, alt: "Tostada de pavo con huevo revuelto", name: "tostada-pavo.webp" },
    { src: `${P}/matcha-mango.webp?v=2`, alt: "Matcha con mango de Deseos", name: "matcha-mango.webp" },
    { src: `${P}/interior.webp`, alt: "Interior de Deseos Brunch & Coffee", name: "interior.webp" },
    { src: `${P}/interior-wide.webp`, alt: "Barra de Deseos Brunch & Coffee", name: "interior-wide.webp" },
    // Pizzas : 5 photos qui remplissent 3 rangées pleines sur 4 colonnes (span imposé).
    { src: `${P}/pizzas/pizza-atun.webp`, alt: "Pizza de atún", name: "pizza-atun.webp", span: "sm:col-span-2 sm:row-span-2" },
    { src: `${P}/pizzas/pizza-margarita.webp`, alt: "Pizza con aceitunas y albahaca", name: "pizza-margarita.webp", span: "col-span-2" },
    { src: `${P}/pizzas/pizza-vegetariana.webp`, alt: "Pizza vegetariana", name: "pizza-vegetariana.webp", span: "sm:row-span-2" },
    { src: `${P}/pizzas/pizza-pollo.webp`, alt: "Pizza de pollo y queso azul", name: "pizza-pollo.webp", span: "sm:row-span-2" },
    { src: `${P}/pizzas/pizza-carne-pollo.webp`, alt: "Pizza de carne picada y pollo", name: "pizza-carne-pollo.webp", span: "sm:col-span-2" },
  ],
};
